import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  inboundCreators,
  inventoryCreators,
  returnDisposalCreators,
  settlementCreators
} from '../../state';

export const useActions = () => {
  const dispatch = useDispatch();

  return bindActionCreators(
    {
      ...inboundCreators,
      ...inventoryCreators,
      ...returnDisposalCreators,
      ...settlementCreators
    },
    dispatch
  );
};
